// extracted by mini-css-extract-plugin
export default {"arrow":"Pagination_arrow__RUtYi"};